
import React from 'react'
import {
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter
} from 'reactstrap';

const ShowInvitations = ({ showModal, hideModal, invitations, propertyId, voucherList, handleConnectedVoucher }) => {
    return (
        <Modal
            isOpen={showModal}
            toggle={hideModal}
            size="lg"
            style={{ maxWidth: '30%' }}
        >
            <ModalHeader toggle={hideModal}><h3>Pending Vouchers invitations</h3></ModalHeader>
            <ModalBody>
                {invitations !== undefined && invitations.map((m, index) => {
                    if (m.sellerPropertyId === propertyId && voucherList.filter((v) => v.invitationId === m.invitationId && v.approvalStatus === '1').length > 0 && (m.type !== 'Sell')) {
                        return (
                            <div className="pl-2 d-flex flex-grow-1 min-width-zero" key={index} >
                                <div className="card-body align-self-center d-flex flex-column flex-lg-row justify-content-between min-width-zero align-items-lg-center">
                                    <p className="mb-1 text-medium">{m.propertyName}</p>
                                    <p className="mb-1  text-medium"> <Button color="primary" onClick={() => { handleConnectedVoucher(m.invitationId, m.groups, m.propertys, m.groupId, m.propertyId); hideModal(); }}>
                                        Vouchers
                                    </Button>
                                    </p>
                                </div>
                            </div>
                        )
                    }
                })
                }
            </ModalBody >
            {/* <ModalFooter>
                <Button onClick={hideModal}>
                    Close
                </Button>
            </ModalFooter> */}
        </Modal >
    )
}
export default ShowInvitations;